import { createActions, createReducer } from 'reduxsauce'

import ConsultaRepassesFundosInstitutosPrevidenciariosService from '../../servicos/ConsultaRepassesFundosInstitutosPrevidenciariosService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaRepassesFundosInstitutosPrevidenciariosInicio: [],
    buscaConsultaRepassesFundosInstitutosPrevidenciariosErro: ['erro'],
    buscaConsultaRepassesFundosInstitutosPrevidenciariosSucesso: ['consultaRepassesFundosInstitutosPrevidenciarios'],
    limpar: [],
    setConsultaRepassesFundosInstitutosPrevidenciariosEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaRepassesFundosInstitutosPrevidenciarios = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaRepassesFundosInstitutosPrevidenciariosInicio())
        let serv = new ConsultaRepassesFundosInstitutosPrevidenciariosService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaRepassesFundosInstitutosPrevidenciariosSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaRepassesFundosInstitutosPrevidenciariosErro(error)))
    }
}

const buscaConsultaRepassesFundosInstitutosPrevidenciariosInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaRepassesFundosInstitutosPrevidenciariosErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaRepassesFundosInstitutosPrevidenciariosSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaRepassesFundosInstitutosPrevidenciarios.resultado,
        dataSincronizacaoDados: action.consultaRepassesFundosInstitutosPrevidenciarios.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaRepassesFundosInstitutosPrevidenciariosEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_REPASSES_FUNDOS_INSTITUTOS_PREVIDENCIARIOS_INICIO]: buscaConsultaRepassesFundosInstitutosPrevidenciariosInicio,
    [Types.BUSCA_CONSULTA_REPASSES_FUNDOS_INSTITUTOS_PREVIDENCIARIOS_ERRO]: buscaConsultaRepassesFundosInstitutosPrevidenciariosErro,
    [Types.BUSCA_CONSULTA_REPASSES_FUNDOS_INSTITUTOS_PREVIDENCIARIOS_SUCESSO]: buscaConsultaRepassesFundosInstitutosPrevidenciariosSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_REPASSES_FUNDOS_INSTITUTOS_PREVIDENCIARIOS_ESTADO_DT]: setConsultaRepassesFundosInstitutosPrevidenciariosEstadoDT,
})
